<template>
  <div class="container">
    <!-- <nav-bar rightShow="false" @leftClick="leftClick"></nav-bar> -->
    <div class="item-cont">
      <div class="pricelab">支付金额</div>
      <div class="price">¥{{price}}</div>
      <div class="menu-content">
        <menu-list name="日历名称" :subName="name" rightIcon="false"></menu-list>
        <menu-list name="订单ID" :subName="number" rightIcon="false"></menu-list>
        <menu-list name="设备ID" :subName="device" rightIcon="false"></menu-list>
        <menu-list name="购买日期" :subName="buytime" rightIcon="false"></menu-list>
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from '../../components/NavBar/NavBar.vue'
import MenuList from '../../components/MenuList/MenuList.vue'
import Common from '../../assets/js/common.js'

export default {
  components: {
    NavBar,
    MenuList
  },
  data () {
    return {
      name: this.$route.query.name,
      price: this.$route.query.price,
      number: this.$route.query.number,
      device: this.$route.query.device,
      buytime: this.$route.query.buytime
    }
  },
  methods: {
    leftClick () {
      this.$router.back()
    }
  },
  created () {
    Common.setTitle('购买记录详情')
  }
}
</script>
<style lang="stylus" scoped>
.item-cont {
  background-color: #ffffff;
  border-top: 1px solid #ededed;
  padding-top: 4.97vh;

  .pricelab {
    width: calc(15vh);
    height: 4vh;
    margin: 0 auto;
    text-align: center;
    font-size: 12px;
  }

  .price {
    width: calc(14vh);
    height: 5vh;
    margin: 0 auto;
    text-align: center;
    font-size: 26px;
    color: #FF0000;
  }

  .menu-content {
    padding: 4.97vh 50px 0;
    background: #ffffff;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/BuyChannelDetail/BuyChannelDetail.vue